<template>
  <div class="Fuell-table--row">
    <div
      class="Fuell-Table--item"
      @click="emitTransaction"
    >
      <div
        class="transaction-status"
        :class="transactionStatusLabelClass"
      >
        <span class="ellipsis text-left">
          {{transactionStatusLabel}}
          <img
            alt="icon-processing-transaction"
            v-if="transactionIsProcessing"
            :src="require('@/assets/img/icons/icon-watch.svg')"
            class="pending-icon"
          />
        </span>

      </div>
    </div>
    <div
      class="Fuell-Table--item Fuell-Table--item-group"
      @click="emitTransaction"
    >
      <span class="text-bold">
        {{transactionUserNameAndLastName}}
      </span>
      <span class="transaction-date">
        {{ transactionDate | formatTheDate('short') }}
        <img
          v-if="transactionIsPending"
          :src="require('@/assets/img/icons/icon-watch.svg')"
          class="pending-icon"
          alt="icon-pending-transaction"
        />
      </span>
    </div>
    <div
      class="Fuell-Table--item Fuell-Table--item-group"
      @click="emitTransaction"
    >
      <span
        class="amount text-bold"
        :class="{
        pending: transactionIsPending,
        declined: transactionIsDeclined,
        refund: transactionIsRefund
      }"
      >
        {{
        transactionAmmount
          | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          })
      }}
      </span>
      <span class="ellipsis">{{transactionMerchant}}</span>
    </div>
    <div
      class="Fuell-Table--item Fuell-Table--item-group"
      @click="emitTransaction"
    >
      <span class="ellipsis">{{transactionBudgetName}}</span>
      <span class="ellipsis"> {{transactionPaymentMethod}}</span>
    </div>
    <div class="Fuell-Table--item">
      <template v-if="transactionReceipt && transactionReceipt.receiptMedia && transactionReceipt.receiptMedia.length > 0">
        <button
          @click="emitShowReceiptModal"
          class="Fuell-IconButton Fuell-IconButton--no-margin clickable"
        >
          <img
            :src="require('@/assets/img/icons/icon-receipt.svg')"
            alt="receipts"
          />
        </button>
      </template>

    </div>
  </div>
</template>

<script>
import { COLUMNS } from '@/modules/transactions/_constants/Columns'
import _transactionsTableRowInfo from '../../_mixins/_transactionsTableRowInfo'
import _transactionStatusHandlerMixin from '../../_mixins/_transactionStatusHandlerMixin'
import _mediaResourceHandlerMixin from '@/components/Commons/_mixins/_mediaResourceHandlerMixin'

export default {
  name: 'TransactionsSmallTableRow',
  props: {
    transaction: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    isExportTable: {
      type: Boolean,
      default: false
    }

  },
  mixins: [_transactionsTableRowInfo, _transactionStatusHandlerMixin, _mediaResourceHandlerMixin],
  data () {
    return {
      isSubmitting: false,
      transactionSelected: false
    }
  },
  computed: {
    COLUMNS () {
      return COLUMNS
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    },
    transactionIsProcessing () {
      return this.transaction.processing
    }
  },
  methods: {
    emitTransaction () {
      if (
        this.transaction.status.code === 'KO' ||
        this.transactionIsAuthorization
      ) {
        return
      }

      if (this.transactionType === 'EXPENSE') {
        this.emitExpenseModalHandler()
        return
      }
      this.$emit('showTransactionModal', this.transaction)
    },
    emitExpenseModalHandler () {
      if (this.isMileage) {
        this.$emit('showMileageModal', this.transaction.id)
        return
      }
      if (this.isDiet) {
        this.$emit('showDietModal', this.transaction.id)
        return
      }
      this.$emit('showTransactionModal', this.transaction, 'expense')
    },
    emitShowReceiptModal () {
      this.$store.dispatch('TransactionsStore/setReceiptModalIsOpen', 'NONE')
      this.$emit('showReceiptModal', { transactionId: this.transaction.id })
    }
  },
  watch: {
    'transaction.isCompleted': function (newV, oldV) {
      const expenses = this.transaction.type.code === 'EXPENSE'
      this.$store.dispatch('TransactionsStore/fetchTransactionDashboard', expenses)
    }
  }
}
</script>

<style scoped src="@/assets/styles/multiselect/table.css"></style>

<style lang="scss" scoped>
.text-bold {
  font-weight: 500;
  color: var(--text-heading);
}
.Fuell-table--row {
  display: grid;
  grid-template-columns:
    minmax(100px, 140px) minmax(150px, 175px) minmax(120px, 130px)
    minmax(160px, 185px) 45px;
}
.Fuell-table--row > .Fuell-Table--item:last-child {
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    margin-right: 10px;
  }
}
span {
  width: 100%;
  text-align: center;
}
.Fuell-Table--item-group {
  display: flex;
  flex-direction: column;
}

.spinner-loading >>> .py-4 {
  height: 24px;
  width: 24px;
  line-height: 24px;
  padding: 0px !important;
}
.pending {
  color: var(--gray);
  opacity: 0.72;
}
.refund {
  color: var(--semantic-positive-main);
}
.transaction-date .pending-icon {
  position: relative;
  left: 2px;
  top: -6px;
}
.declined {
  color: var(--red);
  text-decoration: line-through;
}
.declined-icon {
  width: 20px;
  height: 20px;
}
.declined-badge {
  margin-right: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08), 0 3px 6px 0 rgba(0, 0, 0, 0.02);
}
.amount {
  font-weight: 500;
}
.transaction-status {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .pending-icon {
    position: relative;
    right: 0px;
    top: -6px;
    width: 10px;
    height: 10px;
  }
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.transaction-locked-icon {
  width: 16px;
  height: 16px;
  margin-left: auto;
  margin-right: 5px;
}
</style>

<style>
.budgets_select .multiselect__option--disabled {
  background-color: white !important;
  color: var(--gray);
}
.image-big {
  display: block;
  width: 194px;
  height: 270px;
  border-radius: 16px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
